import styled from 'styled-components';
import Button from '@ui-library/button';

export const StyledContainer = styled.div`
  padding: 50px 80px;
`;

export const IconCardListContainer = styled.div`
  padding: 50px;
  margin-bottom: 30px > div {

  }
  overflow-y: scroll;
  height: 70vh;
`;

export const SourceNameInputContainer = styled.div`
  width: 475px;
  margin: auto;
  padding: 50px 0;
  input {
    width: 100%;
  }
`;

export const SourceSettingsContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`;

export const CreateAccountButton = styled(Button)`
  min-width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  margin-top: 16px;
`;

export const ExistingAccounts = styled.div`
  max-height: 360px;
  overflow: auto;
`;
